import { UntypedFormControl } from '@angular/forms';

import { type Destroyable } from './destroyable.types';

/**
 * QuestionControl is derived from FormControl with the destroy method that allows
 * executing some logic when control is being destroyed.
 * For instance, it allows unsubscribing from subscriptions.
 * Also, this method is called in the QuestionControlService when FormGroup is destroyed.
 */
export class QuestionControl extends UntypedFormControl implements Destroyable {
  public destroy(): void {}
}
